import { useNavigate } from 'react-router';
import {
  FontAwesomeIcon,
  IconProp,
  GrcButton,
  GrcButtonStylingMode,
  faboltclassicregular
} from '@grc/ui-package';
import { useI18nState } from '../../../../stores/settings/language-context';
import './quick-actions-card.scss';

const createOrderRoute = '/ordersquotations/createorder';
const createQuoteRoute = '/ordersquotations/createquote';
const contactSupportRoute = '/supportcontacts';

export default function QuickActionsCard() {
  const { localeData } = useI18nState();
  const navigate = useNavigate();

  const actions = [
    {
      key: 'create-order',
      label: localeData.CreateNewOrder,
      icon: 'plus',
      onClick: () => navigate(createOrderRoute)
    },
    {
      key: 'create-quote',
      label: localeData.CreateQuote,
      icon: 'doc',
      onClick: () => navigate(createQuoteRoute)
    },
    {
      key: 'create-contact-support',
      label: localeData.CreateContactSupport,
      icon: 'email',
      onClick: () => navigate(contactSupportRoute)
    }
  ];

  return (
    <div
      className="operational-stat-card quick-actions-card"
      role="group"
      aria-label={localeData.QuickActions}
      data-testid="quick_actions_card"
    >
      <div className="operational-stat-card-header d-flex align-items-center">
        <span className="operational-stat-card-icon d-flex align-items-center justify-content-center">
          <FontAwesomeIcon icon={faboltclassicregular as IconProp} />
        </span>
        <h6 className="operational-stat-card-title mb-0 ms-2">
          {localeData.QuickActions}
        </h6>
      </div>

      <div className="quick-actions-card-body d-flex flex-column">
        {actions.map(action => (
          <GrcButton
            key={action.key}
            text={action.label}
            icon={action.icon}
            stylingMode={GrcButtonStylingMode.Outlined}
            onClick={action.onClick}
            elementAttr={{ 'data-testid': `${action.key}_button` }}
          />
        ))}
      </div>
    </div>
  );
}
